<template>
  <div class="p-the-c01-item-thumbnails-pc">
    <template v-if="haveThumnails">
      <img :src="main.image_url" class="p-the-c01-item-thumbnails-pc__main" />
      <div class="p-the-c01-item-thumbnails-pc__sub">
        <div
          v-for="(sub, key) in thumbnails"
          :key="key"
          class="p-the-c01-item-thumbnails-pc__sub__panel"
          :style="selectedStyle(sub)"
          @click="selectSub(sub)"
        >
          <img :src="sub.image_url" />
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import commons from "@/common/store/modules/commons";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";

@Options({
  watch: {
    thumbnails(){
      this.initMain();
    }
  }
})
export default class TheC01ItemThumbnailsPc extends Vue {
  thumbnails!: any;

  main = "";

  get haveThumnails() {
    return this.thumbnails.length > 0;
  }

  get colorCode() {
    return commons.OrgPageSpecific?.page_color;
  }

  selectSub(sub: any) {
    this.main = sub;
  }
  selectedStyle(sub: any) {
    return this.main === sub ? `border: 1px solid ${this.colorCode}` : "";
  }
  initMain() {
    this.main = this.haveThumnails ? this.thumbnails[0] : {};
  }

  created() {
    this.initMain();
  }
}
</script>

<style lang="scss" scoped>
.p-the-c01-item-thumbnails-pc {
  &__main {
    max-width: inherit;
    width: 100%;
  }

  &__sub {
    display: grid;
    gap: rem(8);
    grid-template-columns: repeat(6, rem(48));
    margin-top: rem(24);

    &__panel {
      border: px(1) solid $common-gray-border;
      cursor: pointer;
    }
  }
}
</style>
